import React from "react";

const ErrorPage = () => {
  return (
    <div>
      <p>Error: Path does not exists!!!</p>
    </div>
  );
};

export default ErrorPage;
